import {DatePicker as GWCDatePicker, RangeDatePicker as GWCRangeDatePicker} from '@gwc/main'

export const DatePicker = GWCDatePicker.Simple

export const RangeDatePicker = GWCRangeDatePicker.Simple
